module.exports = __webpack_public_path__ + "static/media/early-warning-signs-large@3x.dcceddae.png";